import "./Photos.css";

import FadeInSection from "../../Components/FadeInSection/FadeInSection";

export default function Photos() {
	return (
		<div className="photos">
			<div className="photoSectionContainer">


				<FadeInSection>
					<div className="photoSection">
						<div className="container span2">
							<div className="banner1 banner"></div>
						</div>
						<div className="container span1">
							<div className="banner2 banner"></div>
						</div>
					</div>
				</FadeInSection>

				<FadeInSection>
					<div className="photoSection">
						<div className="container span1">
							<div className="banner3 banner"></div>
						</div>
						<div className="container span1">
							<div className="banner4 banner"></div>
						</div>
						<div className="container span1">
							<div className="banner5 banner"></div>
						</div>
					</div>
				</FadeInSection>

				<FadeInSection>
					<div className="photoSection">
						<div className="container span1">
							<div className="banner6 banner"></div>
						</div>
						<div className="container span2">
							<div className="banner7 banner"></div>
						</div>
					</div>
				</FadeInSection>

				<FadeInSection>
					<div className="photoSection">
						<div className="container span1">
							<div className="banner8 banner"></div>
						</div>
						<div className="container span1">
							<div className="banner9 banner"></div>
						</div>
						<div className="container span1">
							<div className="banner10 banner"></div>
						</div>
					</div>
				</FadeInSection>
			</div>
		</div>
	);
}